module.exports = __webpack_public_path__ + "img/下载.41a71410.png";